import { Box, Typography } from "@mui/material";
import { orderFlagColor } from "../../utils/Constant";
import OrderFlag from "./order-flag";

export default function OrderTableRushCell({ rowData }: any) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", height: "inherit" }}>
      {rowData.isRushInspection && <OrderFlag color={orderFlagColor.rush} />}
      <Typography sx={{ ml: 1 }}>
        {rowData.isRushInspection ? "Yes" : "No"}
      </Typography>
    </Box>
  );
}